<template>
  <div class="loader-container">
    <v-progress-circular
      indeterminate
      color="primary"
      size="40"
    />
  </div>
</template>

<script>
export default {
  name: "Loader"
};
</script>

<style scoped>
.loader-container {
  display: flex;
  justify-content: center;
  padding: 20px;
}
</style>
